// src/components/CookieBanner.jsx
import React, { useState, useEffect } from "react";

const COOKIE_KEY = "cookieConsent";

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [consent, setConsent] = useState({
    essential: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const saved = localStorage.getItem(COOKIE_KEY);
    if (!saved) {
      setShowBanner(true);
    } else {
      setConsent(JSON.parse(saved));
    }
  }, []);

  const saveConsent = (newConsent) => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify(newConsent));
    setConsent(newConsent);
    setShowBanner(false);
    applyCookies(newConsent);
  };

  const applyCookies = (consentObj) => {
    // TODO: ici tu peux activer/désactiver tes scripts tiers selon le consentement
    console.log("Consentement appliqué :", consentObj);
  };

  const handleAcceptAll = () => {
    saveConsent({ essential: true, analytics: true, marketing: true });
  };

  const handleAcceptSelected = () => {
    saveConsent(consent);
  };

  if (!showBanner) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        background: "#f5f5f5",
        borderTop: "1px solid #ccc",
        padding: "16px",
        zIndex: 1000,
        boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <p style={{ margin: "0 0 8px 0" }}>
        Nous utilisons des cookies pour améliorer votre expérience. Vous pouvez
        accepter tout ou personnaliser votre choix.
      </p>

      <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        <label>
          <input type="checkbox" checked disabled /> Essentiels
        </label>
        <label>
          <input
            type="checkbox"
            checked={consent.analytics}
            onChange={(e) =>
              setConsent({ ...consent, analytics: e.target.checked })
            }
          />{" "}
          Analytics
        </label>
        <label>
          <input
            type="checkbox"
            checked={consent.marketing}
            onChange={(e) =>
              setConsent({ ...consent, marketing: e.target.checked })
            }
          />{" "}
          Marketing
        </label>
      </div>

      <div style={{ marginTop: 12, display: "flex", gap: 12, flexWrap: "wrap" }}>
        <button
          onClick={handleAcceptAll}
          style={{
            padding: "8px 16px",
            background: "#30C6C3",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Tout accepter
        </button>

        <button
          onClick={handleAcceptSelected}
          style={{
            padding: "8px 16px",
            background: "#fff",
            color: "#0B0B0B",
            border: "1px solid #ccc",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Accepter la sélection
        </button>
      </div>
    </div>
  );
}

// Helper à placer dans App.jsx footer
export const resetCookiesConsent = () => {
  localStorage.removeItem(COOKIE_KEY);
  window.location.reload(); // recharge pour appliquer le consentement réinitialisé
};

